import { Link } from "react-router-dom";
import { useState } from "react";
import { SEOHead } from "@/components/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/Breadcrumb";

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const breadcrumbItems = [{ name: "关于我们" }];

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus("submitting");
    setFormError("");

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get("phone_alt")?.toString().trim();

    if (honeypot) {
      setFormStatus("success");
      form.reset();
      return;
    }

    setFormStatus("success");
    form.reset();
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "53吃瓜",
    alternateName: "53吃瓜网",
    description: "53吃瓜持续追踪全网吃瓜52最新动态，覆盖53吃瓜圈内部讨论与本周必看娱乐爆料合集。",
    url: typeof window !== "undefined" ? window.location.origin : "",
    logo: {
      "@type": "ImageObject",
      url: `${typeof window !== "undefined" ? window.location.origin : ""}/vite.svg`,
    },
    sameAs: ["http://ihthrnq.com/"],
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "客服咨询",
        email: "hello@ihthrnq.com",
      },
      {
        "@type": "ContactPoint",
        contactType: "商务合作",
        email: "hello@ihthrnq.com",
      },
      {
        "@type": "ContactPoint",
        contactType: "爆料投稿",
        email: "hello@ihthrnq.com",
      },
    ],
  };

  const aboutPageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于53吃瓜 - 品牌介绍与联系方式",
    description: "了解53吃瓜网的品牌故事、平台定位与联系方式。",
    url: typeof window !== "undefined" ? window.location.href : "",
    mainEntity: orgSchema,
  };

  return (
    <>
      <SEOHead
        title="关于53吃瓜 - 品牌介绍 | 53吃瓜网"
        description="了解53吃瓜网的品牌故事、平台定位与联系方式。53吃瓜持续追踪全网吃瓜52最新动态，覆盖53吃瓜圈内部讨论与本周必看娱乐爆料合集。"
        jsonLd={[orgSchema, aboutPageSchema]}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-20 pb-12 md:pb-20 bg-foreground-950 min-h-[350px] md:min-h-[450px] flex items-end">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20newsroom%20editorial%20office%2C%20dark%20moody%20atmosphere%2C%20multiple%20computer%20screens%20glowing%2C%20red%20and%20orange%20accent%20lighting%2C%20sleek%20minimal%20design%2C%20cinematic%20style%2C%20professional%20media%20environment&width=1600&height=900&seq=about-hero&orientation=landscape"
            alt="关于53吃瓜"
            className="w-full h-full object-cover object-top opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
        </div>
        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={breadcrumbItems} />
            <h1 className="font-heading font-black text-white text-4xl md:text-5xl lg:text-6xl leading-tight mt-4 mb-4">
              关于53吃瓜
            </h1>
            <p className="text-white/70 text-base md:text-lg max-w-xl mb-6">
              真实爆料 · 全网追踪 · 娱乐八卦第一门户
            </p>
          </div>
        </div>
      </section>

      <main className="bg-background-50">
        {/* Brand Intro */}
        <section className="py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                {/* Left - Image */}
                <div className="order-2 lg:order-1">
                  <div className="rounded-3xl overflow-hidden shadow-xl">
                    <img
                      src="https://readdy.ai/api/search-image?query=modern%20abstract%20media%20concept%20art%2C%20floating%20newspaper%20pages%20and%20digital%20screens%2C%20dark%20elegant%20background%2C%20red%20and%20orange%20light%20accents%2C%20minimalist%20geometric%20composition%2C%20cinematic%20style%2C%20premium%20editorial%20aesthetic&width=800&height=600&seq=about-brand&orientation=landscape"
                      alt="53吃瓜品牌"
                      className="w-full aspect-[4/3] object-cover object-top"
                    />
                  </div>
                </div>

                {/* Right - Content */}
                <div className="order-1 lg:order-2">
                  <span className="inline-flex items-center px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-bold mb-5">
                    品牌介绍
                  </span>
                  <h2 className="font-heading font-black text-foreground-950 text-3xl md:text-4xl leading-tight mb-4">
                    专注娱乐八卦
                    <br />
                    <span className="text-primary-500">真实爆料全网追踪</span>
                  </h2>
                  <div className="space-y-4 text-foreground-600 text-base leading-relaxed">
                    <p>
                      53吃瓜网成立于2024年，是一家专注于娱乐八卦、明星爆料、圈内猛料追踪的互联网资讯平台。我们致力于为网友提供最新、最真实的娱乐圈动态。
                    </p>
                    <p>
                      我们的团队由资深娱乐记者、行业观察员和数据分析专家组成，每天24小时不间断追踪全网热点。从微博热搜到豆瓣小组，从贴吧爆料到小红书吃瓜，我们覆盖所有主流社交平台的信息源。
                    </p>
                    <p>
                      "53吃瓜"这个名字来源于互联网黑话中的"吃瓜"文化——53代表"我要上"的谐音，寓意我们要让每一个爆料都上到公众视野。我们的口号是：真实爆料，全网追踪，让每一个瓜都保熟。
                    </p>
                  </div>
                  <div className="flex flex-wrap gap-4 mt-8">
                    <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-secondary-100 text-secondary-800 text-sm">
                      <i className="ri-shield-check-line text-accent-500" />
                      信息真实可靠
                    </div>
                    <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-secondary-100 text-secondary-800 text-sm">
                      <i className="ri-time-line text-accent-500" />
                      7x24小时更新
                    </div>
                    <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-secondary-100 text-secondary-800 text-sm">
                      <i className="ri-global-line text-accent-500" />
                      全网信息覆盖
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
                {[
                  { number: "50万+", label: "日均访问量", icon: "ri-user-follow-line" },
                  { number: "10万+", label: "累计爆料", icon: "ri-article-line" },
                  { number: "200+", label: "合作媒体", icon: "ri-newspaper-line" },
                  { number: "99%", label: "用户满意度", icon: "ri-emotion-happy-line" },
                ].map((stat) => (
                  <div key={stat.label} className="text-center p-6 rounded-2xl bg-background-50 border border-background-200/70">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-4">
                      <i className={`${stat.icon} text-xl`} />
                    </div>
                    <p className="font-heading font-black text-foreground-950 text-2xl md:text-3xl mb-1">{stat.number}</p>
                    <p className="text-foreground-500 text-sm">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                {/* Left - Image */}
                <div className="relative min-h-[400px] md:min-h-[500px] rounded-3xl lg:rounded-r-none overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20creative%20workspace%20meeting%20room%2C%20people%20collaborating%20around%20table%2C%20warm%20red%20and%20orange%20accent%20lighting%2C%20glass%20walls%20and%20modern%20furniture%2C%20professional%20team%20discussion%2C%20cinematic%20style%2C%20soft%20warm%20tones&width=960&height=700&seq=about-contact&orientation=landscape"
                    alt="联系53吃瓜"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent" />
                  <div className="absolute top-6 left-6">
                    <span className="text-white/80 text-xs font-medium tracking-wider uppercase">
                      商务合作
                    </span>
                  </div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <h3 className="font-heading font-black text-white text-3xl md:text-4xl lg:text-5xl leading-tight">
                      商务合作
                      <br />
                      爆料投稿
                    </h3>
                  </div>
                </div>

                {/* Right - Contact Form */}
                <div className="flex flex-col justify-center p-8 md:p-12 lg:p-16 bg-background-50 lg:bg-background-100 rounded-3xl lg:rounded-l-none">
                  <h3 className="font-heading font-black text-foreground-950 text-2xl md:text-3xl text-center mb-2">
                    联系我们
                  </h3>
                  <p className="text-foreground-500 text-base text-center mb-8">
                    商务合作、爆料投稿、意见反馈，欢迎随时联系
                  </p>

                  {/* Contact Info */}
                  <div className="space-y-4 mb-8">
                    <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                        <i className="ri-mail-line" />
                      </div>
                      <div>
                        <p className="text-foreground-400 text-xs">客服邮箱</p>
                        <p className="text-foreground-950 text-sm font-medium">hello@ihthrnq.com</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                        <i className="ri-briefcase-line" />
                      </div>
                      <div>
                        <p className="text-foreground-400 text-xs">商务合作</p>
                        <p className="text-foreground-950 text-sm font-medium">hello@ihthrnq.com</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                        <i className="ri-megaphone-line" />
                      </div>
                      <div>
                        <p className="text-foreground-400 text-xs">爆料投稿</p>
                        <p className="text-foreground-950 text-sm font-medium">hello@ihthrnq.com</p>
                      </div>
                    </div>
                  </div>

                  {/* Quick Contact Form */}
                  <form
                    onSubmit={handleSubmit}
                    className="space-y-4"
                  >
                      <input
                        type="text"
                        name="phone_alt"
                        className="hp-field"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                      />
                      <div>
                        <input
                          type="text"
                          name="name"
                          placeholder="您的称呼"
                          required
                          className="w-full px-4 py-3 rounded-xl bg-background-50 border border-background-200 text-foreground-950 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                        />
                      </div>
                      <div>
                        <input
                          type="email"
                          name="email"
                          placeholder="您的邮箱"
                          required
                          className="w-full px-4 py-3 rounded-xl bg-background-50 border border-background-200 text-foreground-950 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                        />
                      </div>
                      <div>
                        <textarea
                          name="message"
                          placeholder="请输入您的留言（最多500字）"
                          required
                          maxLength={500}
                          rows={3}
                          className="w-full px-4 py-3 rounded-xl bg-background-50 border border-background-200 text-foreground-950 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                        />
                        <p className="text-foreground-400 text-xs mt-1 text-right">最多500字</p>
                      </div>
                      <button
                        type="submit"
                        disabled={formStatus === "submitting"}
                        className="w-full flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-white text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-60"
                      >
                        {formStatus === "submitting" ? (
                          <>
                            <i className="ri-loader-4-line animate-spin" />
                            提交中...
                          </>
                        ) : (
                          <>
                            提交留言
                            <i className="ri-send-plane-line" />
                          </>
                        )}
                      </button>
                      {formStatus === "success" && (
                        <p className="text-green-600 text-sm text-center">
                          <i className="ri-check-line mr-1" />
                          提交成功！我们会尽快回复您。
                        </p>
                      )}
                      {formStatus === "error" && formError && (
                        <p className="text-primary-500 text-sm text-center">
                          <i className="ri-error-warning-line mr-1" />
                          {formError}
                        </p>
                      )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
